export const sortByFavoritesAndLabel = <T>(
  items: T[],
  favoriteSet: Set<string>,
  getKey: (item: T) => string,
  getLabel: (item: T) => string
) =>
  items.toSorted((a, b) => {
    const aIsFavorite = favoriteSet.has(getKey(a));
    const bIsFavorite = favoriteSet.has(getKey(b));
    return aIsFavorite !== bIsFavorite ? (bIsFavorite ? 1 : -1) : getLabel(a).localeCompare(getLabel(b));
  });
